
/** an Ethereum hash - should be 32 bytes long */
export declare type EthereumHash = `0x${string}` & { };

/** a block hash - an entherum 0x hash with 66 characters in length*/
export declare type BlockHash = EthereumHash & { };

/** check if a string is a valid block hash - 66 characters, starts with 0x, and is hex */
export const isBlockHash = (value: unknown): value is BlockHash =>
  typeof value === "string" && value.length === 66 && /^0x[0-9a-fA-F]+$/.test(value);

/** a transaction hash */
export declare type TransactionHash = EthereumHash & { };
